import { render } from "./VehicleEntityLink.vue?vue&type=template&id=38d503d3&scoped=true"
import script from "./VehicleEntityLink.vue?vue&type=script&lang=js"
export * from "./VehicleEntityLink.vue?vue&type=script&lang=js"

import "./VehicleEntityLink.vue?vue&type=style&index=0&id=38d503d3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38d503d3"]])

export default __exports__